import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { I18n as I } from 'react-redux-i18n';
import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { PARTIES_ACTION_TYPES as AT } from './Parties.actions';

export const fetchAuctionPartyEpic = (action$, store) =>
  action$
    .ofType(AT.AUCTION_PARTY_FETCH)
    .mergeMap(({ payload: { id, partyType } }) =>
      Api.fetchParty(id)
        .map(content => ({
          type: AT.AUCTION_PARTY_FETCH_SUCCESS,
          payload: { partyType, ...content },
        }))
        .catch(e => {
          return Observable.of(
            ReduxHelper.createAction(AT.AUCTION_PARTY_FETCH_FAIL, null, e),
          );
        }),
    );

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.PARTIES_FETCH_DATA, Api.fetchPartiesData],
    [
      AT.PARTY_CREATE,
      Api.createParty,
      { successMessage: () => I.t('EPICS_PARTIES_PARTY_CREATED') },
    ],
    [
      AT.PARTY_UPDATE,
      Api.updateParty,
      { successMessage: () => I.t('EPICS_PARTIES_PARTY_UPDATED') },
    ],
    [
      AT.PARTY_DELETE,
      Api.deleteParty,
      { successMessage: () => I.t('EPICS_PARTIES_PARTY_DELETED') },
    ],
    [
      AT.PARTY_ENABLE_DISABLE,
      Api.enableDisableParty,
      { successMessage: () => I.t('EPICS_PARTIES_STATUS_UPDATE') },
    ],
    [AT.PARTY_FETCH, Api.fetchParty],
  ),
  fetchAuctionPartyEpic,
);
